<template>
  <div class="login-wrapper">
    <v-row no-gutters class="fill-height login-row">
      <!-- Login Form Section -->
      <v-col cols="12" md="6" class="login-form-section">
        <div class="login-form-wrapper">
          <div class="brand-section">
            <div class="logo-container">
              <v-img 
                :src="require('../assets/logo.png')" 
                class="brand-logo" 
                contain 
                height="80"
              />
            </div>
            <h1 class="brand-title">مرحباً بك</h1>
            <p class="brand-subtitle">سجل دخولك للوصول إلى نظام إدارة العيادة</p>
          </div>

          <v-card class="login-card" elevation="0" rounded="xl">
            <v-card-text class="login-card-content">
              <div class="form-container">
                <v-text-field
                  v-model="userName"
                  label="اسم المستخدم"
                  outlined
                  rounded
                  class="modern-input"
                  prepend-inner-icon="mdi-account-outline"
                  color="#0096Ab"
                  hide-details="auto"
                ></v-text-field>
                
                <v-text-field
                  v-model="password"
                  type="password"
                  label="كلمة المرور"
                  outlined
                  rounded
                  class="modern-input"
                  prepend-inner-icon="mdi-lock-outline"
                  color="#0096Ab"
                  hide-details="auto"
                  @keyup.enter="login()"
                ></v-text-field>

                <v-btn
                  large
                  rounded
                  block
                  @click="login"
                  class="login-btn"
                  elevation="0"
                >
                  <v-icon left size="20">mdi-login-variant</v-icon>
                  تسجيل دخول
                </v-btn>
              </div>
            </v-card-text>
          </v-card>

          <div class="footer-text">
            <p>© 2024 نظام إدارة العيادة - جميع الحقوق محفوظة</p>
          </div>
        </div>
      </v-col>

      <!-- Image Section -->
      <v-col cols="12" md="6" class="login-image-section">
        <div class="image-overlay">
          <div class="overlay-content">
            <h2 class="overlay-title">نظام إدارة شامل</h2>
            <p class="overlay-subtitle">
              إدارة متكاملة للعيادات والمرضى والمواعيد والصيدلية والتدريب
            </p>
            <div class="feature-list">
              <div class="feature-item">
                <v-icon color="white" size="20">mdi-check-circle</v-icon>
                <span>إدارة المرضى والحجوزات</span>
              </div>
              <div class="feature-item">
                <v-icon color="white" size="20">mdi-check-circle</v-icon>
                <span>نظام الصيدلية المتكامل</span>
              </div>
              <div class="feature-item">
                <v-icon color="white" size="20">mdi-check-circle</v-icon>
                <span>إدارة التدريب والدورات</span>
              </div>
              <div class="feature-item">
                <v-icon color="white" size="20">mdi-check-circle</v-icon>
                <span>التقارير المالية الشاملة</span>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    password: "",
    userName: "",
  }),
  methods: {
    login() {
      let self = this;
      // this.$router.push("/");
      if (self.userName && self.password) {
        let credentials = {
          password: self.password,
          userName: self.userName,
        };
        self.$http
          .post(`${self.$store.state.apiUrl}/login`, credentials)
          .then((res) => {
            // localStorage.setItem("centerLogin", JSON.stringify(res.data.token));
            // location.reload();
            self.$store.state.user = res.data.token;
            self.$store.state.userData = self.parseJwt(res.data.token);
            self.$store.state.hideLogin = true;
            if (this.$store.state.user) {
              self.$store.state.userLogIn = true;
              if (this.$store.state.userData.roleId == 7) {
                self.$router.push("/edo").catch(() => {});
              } else if (this.$store.state.userData.roleId == 8) {
                self.$router.push("/company").catch(() => {});
              } else {
                self.$router.push("/").catch(() => {});
              }
            }
          })
          .catch((e) => {
            console.log(e);
            this.$toasted.error("حدث خطأ الرجاء التأكد من المعلومات");
          });
      } else {
        this.$toasted.error("الرجاء ادخال  اسم المستخدم وكلمة المرور");
      }
    },
    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow-x: hidden;
}

.login-row {
  min-height: 100vh;
  width: 100%;
  margin: 0 !important;
}

.login-form-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
}

.login-form-wrapper {
  width: 100%;
  max-width: 450px;
}

.brand-section {
  text-align: center;
  margin-bottom: 40px;
}

.logo-container {
  background: white;
  border-radius: 20px;
  padding: 20px;
  display: inline-block;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.brand-logo {
  width: 80px;
  height: 80px;
}

.brand-title {
  font-size: 32px;
  font-weight: 700;
  color: #1F2937;
  margin: 16px 0 8px 0;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-subtitle {
  font-size: 16px;
  color: #6B7280;
  margin: 0;
  line-height: 1.5;
}

.login-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 24px;
}

.login-card-content {
  padding: 40px 32px;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.modern-input {
  margin-bottom: 0 !important;
}

.modern-input >>> .v-input__control {
  min-height: 56px;
}

.modern-input >>> .v-text-field__details {
  margin-top: 8px;
}

.modern-input >>> fieldset {
  border-color: rgba(0, 0, 0, 0.12) !important;
  border-width: 2px !important;
}

.modern-input >>> .v-input--is-focused fieldset {
  border-color: #0096Ab !important;
}

.modern-input >>> .v-label {
  color: #6B7280 !important;
  font-weight: 500;
}

.modern-input >>> .v-input--is-focused .v-label {
  color: #0096Ab !important;
}

.login-btn {
  height: 56px !important;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%) !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px;
  margin-top: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 150, 171, 0.3) !important;
}

.login-btn >>> .v-btn__content {
  gap: 8px;
}

.footer-text {
  text-align: center;
  color: #9CA3AF;
  font-size: 14px;
}

.footer-text p {
  margin: 0;
}

.login-image-section {
  background: linear-gradient(135deg, rgba(0, 150, 171, 0.9) 0%, rgba(0, 188, 212, 0.9) 100%), 
              url("./../assets/turath.jpg");
  background-size: cover;
  background-position: center;
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-overlay {
  padding: 60px 40px;
  color: white;
  text-align: center;
  max-width: 500px;
}

.overlay-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.2;
}

.overlay-subtitle {
  font-size: 18px;
  margin-bottom: 40px;
  line-height: 1.6;
  opacity: 0.9;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: right;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 960px) {
  .login-image-section {
    order: 1;
    min-height: 300px;
  }
  
  .login-form-section {
    order: 2;
    min-height: auto;
    padding: 20px;
  }
  
  .overlay-title {
    font-size: 32px;
  }
  
  .overlay-subtitle {
    font-size: 16px;
  }
  
  .image-overlay {
    padding: 40px 20px;
  }
  
  .brand-title {
    font-size: 24px;
  }
  
  .login-card-content {
    padding: 32px 24px;
  }
}

@media (max-width: 600px) {
  .login-form-wrapper {
    max-width: 100%;
  }
  
  .brand-title {
    font-size: 20px;
  }
  
  .brand-subtitle {
    font-size: 14px;
  }
  
  .overlay-title {
    font-size: 24px;
  }
  
  .overlay-subtitle {
    font-size: 14px;
  }
  
  .feature-item {
    font-size: 14px;
  }
  
  .login-card-content {
    padding: 24px 20px;
  }
}
</style>
